export default __webpack_public_path__ + "static/media/blue-dots-top-left.e25e4f4a.svg";